import { EditSettingsAction } from '@leverege/molten/data-viewers'
import { ItemEditor } from '@leverege/ui-attributes'

export default new EditSettingsAction( {
  id : 'petsmart.dataViewers.stations.StationsCardDataViewerEditor',
  matches : { use : 'actionBar', client : 'StationCardDataViewer' },
  editor : ItemEditor,
  title : 'Stations Card Editor',
  versionType : 'stationsCard',
  editorProps : ( opts ) => {
    const { delegate, objectType, blueprint, relationship } = opts.context?.clientProps || {}
    return { delegate, objectType, blueprint, relationship }
  }
} )
